import "../i18n";

type affType = {
  player: string;
  deposit: string;
  cashout: string;
  winLoss: string;
  platformFee: string;
  bonus: string;
  paymentFee: string;
  commission: string;
};

export const dataAffiliate: affType[] = [
  {
    player: "A",
    deposit: "10000",
    cashout: "2000",
    winLoss: "8000",
    platformFee: "1440",
    bonus: "0",
    paymentFee: "450",
    commission: "3055",
  },
  {
    player: "B",
    deposit: "50000",
    cashout: "0",
    winLoss: "50000",
    platformFee: "9000",
    bonus: "0",
    paymentFee: "2000",
    commission: "19500",
  },
  {
    player: "C",
    deposit: "0",
    cashout: "0",
    winLoss: "200",
    platformFee: "36",
    bonus: "200",
    paymentFee: "0",
    commission: "-18",
  },
  {
    player: "D",
    deposit: "500",
    cashout: "0",
    winLoss: "1000",
    platformFee: "180",
    bonus: "500",
    paymentFee: "20",
    commission: "150",
  },
  {
    player: "E",
    deposit: "10000",
    cashout: "40000",
    winLoss: "-20000",
    platformFee: "0",
    bonus: "10000",
    paymentFee: "1400",
    commission: "-15700",
  },
];
